<template>
    <div class="chatbot">
        <div class="chatbot_box" v-if="chatBot">
            <div class="chatbot_box_card">
                <div class="chatbot_box_header">
                    <div class="chatbot_info">
                        <span class="name">How can I help you?</span>
                    </div>
                    <span class="chatbot_close">
                        <i aria-hidden="true" class="fa fa-minus" @click="botBoxHideMethod"></i>
                        <i aria-hidden="true" class="fa fa-window-close ml-3" @click="botClosePopup = true"></i>
                    </span>
                </div>
                <div class="chatbot_box_body" id="messagesBox">
                    <div class="bot_wc_message">
                        <span class="photo"><img src="@/assets/images/ai_bot.png" alt="" class="img-fluid" /></span>
                    </div>
                    <ul class="cb_messages">
                        <li v-for="(message, index) in messages" :key="index"
                            :class="['cb_message_item', message.sender]">
                                <span v-html="encodedMessage(message.text)"></span>
                                <template v-if="index != 0">
                                    <div class="helpful_reactions" v-if="message.sender === 'bot'">
                                        <i class="fa fa-thumbs-up" aria-hidden="true" @click="feedBackSubmitionMethod('helpful', message)" :class="message.feedback == 'helpful' ? 'active' : ''"></i>
                                        <i class="fa fa-thumbs-down" aria-hidden="true" @click="feedBackSubmitionMethod('not_helpful', message)" :class="message.feedback == 'not_helpful' ? 'active' : ''"></i>
                                    </div>
                                </template>
                        </li>
                        <li v-if="isLoading" class="cb_message_item loading">
                            <span>Thinking</span>
                        </li>
                        <template v-else>
                            <li class="suggestion_list" v-if="messages.length == 1">
                                <div class="suggestion_list_item" v-for="(item, index) in suggestionList" :key="index"
                                    @click="suggestionDataSentMethod(item)">
                                    <span class="badge badge-primary">{{ item }}</span>
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="chatbot_box_footer" v-if="textfiledFocus">
                    <div class="form-group">
                        <input type="text" class="form-control" v-model="userInput" @keyup.enter="sendMessage"
                            :disabled="isLoading" placeholder="Type your message..." />
                        <button class="btn" @click="sendMessage" :disabled="!userInput">
                            <svg width="57px" height="54px" viewBox="1496 193 57 54" version="1.1"
                                xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                style="width: 18px; height: 18px;">
                                <g id="Group-9-Copy-3" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
                                    transform="translate(1523.000000, 220.000000) rotate(-270.000000) translate(-1523.000000, -220.000000) translate(1499.000000, 193.000000)">
                                    <path
                                        d="M5.42994667,44.5306122 L16.5955554,44.5306122 L21.049938,20.423658 C21.6518463,17.1661523 26.3121212,17.1441362 26.9447801,20.3958097 L31.6405465,44.5306122 L42.5313185,44.5306122 L23.9806326,7.0871633 L5.42994667,44.5306122 Z M22.0420732,48.0757124 C21.779222,49.4982538 20.5386331,50.5306122 19.0920112,50.5306122 L1.59009899,50.5306122 C-1.20169244,50.5306122 -2.87079654,47.7697069 -1.64625638,45.2980459 L20.8461928,-0.101616237 C22.1967178,-2.8275701 25.7710778,-2.81438868 27.1150723,-0.101616237 L49.6075215,45.2980459 C50.8414042,47.7885641 49.1422456,50.5306122 46.3613062,50.5306122 L29.1679835,50.5306122 C27.7320366,50.5306122 26.4974445,49.5130766 26.2232033,48.1035608 L24.0760553,37.0678766 L22.0420732,48.0757124 Z"
                                        id="sendicon" fill="#ffffff" fill-rule="nonzero"></path>
                                </g>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
            <bot-close-popup v-if="botClosePopup" :socket="webSocket" :sessionId="sessionId"></bot-close-popup>
        </div>
        <div class="chatbox_start_icon" v-else @click="connectWebSocket">
            <span class="chatbot_icon">
                <i class="fa fa-commenting" aria-hidden="true"></i>
            </span>
            <span class="chatbot_name">Say Hello to TukiVita!</span>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { bus } from '@/main';
import showdown from 'showdown';
import confirmationPopup from './confirmationPopup.vue';
export default {
    name: 'ai-chatbot',
    components: {
        'bot-close-popup': confirmationPopup
    },
    props: [],
    data() {
        return {
            token: localStorage.getItem('token') || null,
            selfUserId: '',
            chatBot: false,
            messages: [],
            userInput: '',
            isLoading: false,
            webSocket: null,
            botClosePopup: false,
            suggestionList: ["I need technical support", "I want to learn about Lymphomap's services", "I want to connect with the support team"],
            textfiledFocus: true,
            sessionId:''
        };
    },
    computed: {
    },
    mounted() {
        this.selfUserId = localStorage.getItem('LoginedUserID');
        bus.$on('botClosesPopupBus', (data) => {
            this.botClosePopup = data;
        });
        bus.$on('botClosesConfirmed', (data) => {
            if (data) {
                this.botClosedMethod();
            }
        });
    },
    methods: {
        connectWebSocket() {
            this.chatBot = true;
            if (this.webSocket) return;
            this.webSocket = new WebSocket(
                `wss://${process.env.VUE_APP_WEBSOCKET_BASE_URL}/ws/chatbot/?token=${this.token}`
            );

            this.webSocket.onopen = () => {
                // console.log('WebSocket connection established!');
            };

            this.webSocket.onmessage = (event) => {
                const data = JSON.parse(event.data);
                if(data.session_id){
                    this.sessionId = data.session_id;
                }
                if(data.type != 'feedback_received'){
                    setTimeout(() => {
                        this.messages.push({
                            sender: 'bot',
                            text: data.message,
                            conversation_id: data.conversation_id,
                            feedback:""
                        });
                        this.isLoading = false;
                        this.$nextTick(() => {
                            this.scrollToBottom();
                        });
                       if(data.type == 'session_ended'){
                            this.textfiledFocus = false;
                       }
                    }, data.response_time_ms + 500);
                }
            };

            this.webSocket.onclose = () => {
                this.webSocket = null;
            };
        },
        sendMessage() {
            if (!this.userInput.trim()) {
                return;
            }

            const message = {
                message: this.userInput,
            };

            this.webSocket.send(JSON.stringify(message));

            this.messages.push({
                sender: 'user',
                text: this.userInput
            });

            this.userInput = '';
            this.isLoading = true;
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },
        suggestionDataSentMethod(value) {

            const message = {
                message: value,
            };

            this.webSocket.send(JSON.stringify(message));

            this.messages.push({
                sender: 'user',
                text: value
            });

            this.isLoading = true;
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        },
        scrollToBottom() {
            const elmnt = document.getElementById("messagesBox");
            const scrollHeight = elmnt.scrollHeight;
            const clientHeight = elmnt.clientHeight;
            const scrollTop = elmnt.scrollTop;
            const distanceFromBottom = scrollHeight - (clientHeight + scrollTop);
            const scrollHeightTotal = (distanceFromBottom + clientHeight + scrollTop);
            elmnt.scrollTop = scrollHeightTotal;
        },
        botClosedMethod() {
            // Check if WebSocket exists and is in a state to send data
            if (this.webSocket && this.webSocket.readyState === WebSocket.OPEN) {
                try {
                    const data = {
                        type: "end_session",
                    };
                    this.webSocket.send(JSON.stringify(data));
                } catch (error) {
                    console.error("Failed to send 'end_session' message:", error);
                }
            }

            // Close the WebSocket and clear fields regardless of whether the message was sent
            if (this.webSocket) {
                this.webSocket.close();
                this.sessionId = '';
            }
            this.clearFieldsMethod();
        },
        clearFieldsMethod() {
            this.userInput = '';
            this.messages = [];
            this.botClosePopup = false;
            this.webSocket = null;
            this.loading = false;
            this.textfiledFocus = true;
            this.botBoxHideMethod();
        },
        encodedMessage(message) {
            const converter = new showdown.Converter({
                simplifiedAutoLink: true
            });

            let messageWithLinks = message.replace(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6})/g, '<a href="mailto:$1">$1</a>');

            let htmlOutput = converter.makeHtml(messageWithLinks);

            htmlOutput = htmlOutput.replace(/href="/g, 'target="_blank" href="');

            return htmlOutput;
        },
        botBoxHideMethod(){
           setTimeout(() => {
             this.chatBot = false;
           }, 1)
        },
        feedBackSubmitionMethod(value, data) {
            const message = {
                type: "feedback",
                conversation_id: data.conversation_id,
                feedback: value
            };

            this.webSocket.send(JSON.stringify(message));
            let targetMessage = this.messages.find(item => item.conversation_id === data.conversation_id);
            if (targetMessage) {
                targetMessage.feedback = value;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
// linear-gradient(-30deg, rgb(0 255 113 / 60%), rgb(21 198 0 / 60%) 50%, rgb(38 225 52 / 60%) 0, rgb(66 183 4 / 60%))
$primary-color: linear-gradient(145deg, rgba(56, 193, 25, 0.8), rgba(20, 156, 4, 0.8) 50%, rgba(0, 106, 8, 0.8) 0, rgba(31, 90, 0, 0.95));
$hover-color: #00a735;
$serachbar-color: #109d00;
$badge-color: #ffffff;
$cross-hover-color: #ffc042;
$wc-color: #ffc168;
$send-svg-hcolor: #ffffff;

.chatbot {
    font-family: 'MyriadProRegular', 'Lato', sans-serif;
    letter-spacing: 0.3px;
    position: fixed;
    z-index: 999;
    right: 15px;
    bottom: 20px;

    @keyframes slideUp {
        0% {
            opacity: 0;
            -webkit-transform: translateY(-10px);
            transform: translateY(-10px)
        }

        to {
            opacity: 1;
            -webkit-transform: translateY(0);
            transform: translateY(0)
        }
    }

    @-webkit-keyframes slideUp {
        0% {
            opacity: 0;
            -webkit-transform: translateY(-10px);
            transform: translateY(-10px)
        }

        to {
            opacity: 1;
            -webkit-transform: translateY(0);
            transform: translateY(0)
        }
    }

    @keyframes slidein {
        0% {
            opacity: 0;
            -webkit-transform: translateX(10px);
            transform: translateX(10px)
        }

        to {
            opacity: 1;
            -webkit-transform: translateX(0);
            transform: translateX(0)
        }
    }

    @keyframes zoom-in-zoom-out {
        0% {
            transform: scale(0);
            -webkit-transform: scale(0);
            -moz-transform: scale(0)
        }

        100% {
            transform: scale(1);
            -webkit-transform: scale(1);
            -moz-transform: scale(1)
        }
    }

    @keyframes appear {
        0% {
            opacity: 0;
            -webkit-transform: scale(0);
            transform: scale(0)
        }

        to {
            opacity: 1;
            -webkit-transform: scale(1);
            transform: scale(1)
        }
    }

    @keyframes leftToright {
        0% {
            left: -100%;
        }

        to {
            left: 100%;
        }
    }

    .chatbox_start_icon {
        background: $primary-color;
        border-radius: 80px;
        padding: 8px 18px 10px;
        box-shadow: rgba(22, 26, 30, 0.02) 0px 1px, rgba(22, 26, 30, 0.04) 0px 0px 0px 1px, rgba(22, 26, 30, 0.08) 0px 1px 5px -4px, rgba(22, 26, 30, 0.08) 0px 4px 8px -6px, rgba(22, 26, 30, 0.01) 0px 1px 3px 1px !important;
        cursor: pointer;
        display: flex;
        align-items: center;
        gap: 10px;
        color: $badge-color;
        transform: scale(1);
        transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        @media only screen and (max-width:767px) {
           background: linear-gradient(145deg, rgba(56, 193, 25, 1), rgba(20, 156, 4, 1) 50%, rgba(0, 106, 8, 1) 0, rgba(31, 90, 0, 1));
        }

        &:hover {
            transform: scale(1.1);
            background: $hover-color !important;
        }

        .chatbot_name {
            font-size: 16px;
            line-height: 1;
        }

        .chatbot_icon .fa {
            font-size: 22px;
            line-height: 1;
        }
    }

    .chatbot_box {
        background: linear-gradient(-30deg, rgba(37, 44, 84, 0.98), rgba(0, 0, 0, 0.98) 50%, rgba(38, 38, 38, 0.98) 0, rgba(44, 44, 84, 0.98));
        border: 1px solid rgba(93, 93, 93, .5);
        padding: 0px 0px 10px;
        border-radius: 15px;
        width: 340px;
        opacity: 0;
        -webkit-animation: appear .15s cubic-bezier(.25, .25, .5, 1.1);
        animation: appear .15s cubic-bezier(.25, .25, .5, 1.1);
        -webkit-animation-fill-mode: forwards;
        animation-fill-mode: forwards;
        overflow: hidden;
    }

    .chatbot_box_header {
        background: $primary-color;
        display: flex;
        align-items: center;
        gap: 10px;
        margin: 0px;
        padding: 10px 16px;
        border-radius: 10px 10px 0px 0px;
        justify-content: space-between;

        .chatbot_info {
            display: flex;
            align-items: center;
            gap: 10px;

            .photo {
                width: 40px;
                height: 40px;
                border: 2px solid #ffffff;
                padding: 1px;
                border-radius: 50%;
                overflow: hidden;

                .img-fluid {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .name {
                color: $badge-color;
                font-size: 18px;
                opacity: 0;
                -webkit-animation: slidein .15s .3s;
                animation: slidein .15s .3s;
                -webkit-animation-fill-mode: forwards;
                animation-fill-mode: forwards;
            }
        }

        .chatbot_close {
            line-height: 1;

            .fa {
                color: $badge-color;
                font-size: 22px;
                cursor: pointer;

                // transform: scale(1);
                // transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1);
                // transform-origin: center ceil($number: 0);
                &:hover {
                    color: $cross-hover-color;
                }
            }
        }
    }

    .chatbot_box_body {
        height: 400px;
        padding: 10px 10px 0px;
        overflow-y: auto;

        &::-webkit-scrollbar {
            width: 3px;
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 5px;
            background-color: rgba(37, 44, 84, 0.5);
        }

        .bot_wc_message {
            text-align: center;
            padding: 5px 0 10px;

            .photo {
                width: 110px;
                height: 110px;
                border: 2px solid $wc-color;
                padding: 1px;
                border-radius: 50%;
                overflow: hidden;
                display: inline-block;
                opacity: 0;
                -webkit-animation: slideUp 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
                animation: slideUp 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;

                .img-fluid {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .wc_heading {
                font-size: 20px;
                color: $wc-color;
                line-height: 1.1;
                margin: 5px 0 10px;
                opacity: 0;
                -webkit-animation: slideUp 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
                animation: slideUp 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
                -webkit-animation-delay: 0.05s;
                animation-delay: 0.05s;
            }

            .wc_msg {
                color: $wc-color;
                font-size: 16px;
                margin: 0;
                line-height: 1.2;
                opacity: 0;
                -webkit-animation: slideUp 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
                animation: slideUp 0.85s cubic-bezier(0.65, 0, 0.35, 1) both;
                -webkit-animation-delay: 0.075s;
                animation-delay: 0.075s;
            }
        }

        .cb_messages {
            padding-top: 15px;

            .cb_message_item {
                margin-bottom: 8px;

                span {
                    display: inline-block;
                    margin: 0px;
                    font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
                    font-weight: normal;
                    padding: 4px 8px;
                    border-radius: 6px;
                    line-height: 1.3;
                    font-size: 14px;
                    white-space: pre-wrap;
                    width: fit-content;
                    word-wrap: break-word;
                }

                &.bot {
                    span {
                        background: #233e5152;
                        font-weight: 500;
                        color: #defddf;
                    }
                    .helpful_reactions {
                        display: flex;
                        align-items: center;
                        gap: 10px;
                        margin-top: 4px;
                        .fa{font-size: 14px;color: #defddf;cursor: pointer; &:hover{color: #ffd400;} &.active{color: #ffd400;}}
                    }
                }

                &.user {
                    text-align: right;

                    span {
                        background: #defddf;
                        animation: zoom-in-zoom-out .5s ease-out;
                        -webkit-animation: zoom-in-zoom-out .5s ease-out;
                        -moz-animation: zoom-in-zoom-out .5s ease-out;
                        transform-origin: right bottom;
                        -webkit-transform-origin: right bottom;
                        -moz-transform-origin: right bottom;
                        color: #000000;
                        text-align: left;
                    }
                }

                &.loading {
                    span {
                        color: #9f9f9f;
                        font-weight: 400;
                        position: relative;
                        overflow: hidden;

                        &::before {
                            content: "";
                            position: absolute;
                            top: 0;
                            width: 100%;
                            height: 100%;
                            background: linear-gradient(120deg,
                                    transparent,
                                    rgba(255, 255, 255, 0.2),
                                    transparent);
                            left: -100%;
                            -webkit-animation: leftToright 1.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;
                            animation: leftToright 1.5s cubic-bezier(0.65, 0, 0.35, 1) infinite;
                        }
                    }
                }
            }

            .suggestion_list {
                .badge-primary {
                    background: #3a454159;
                    border: 1px solid rgba(93, 93, 93, 0.5);
                    font-size: 15px;
                    margin: 5px 0;
                    font-weight: normal;
                    padding: 8px 15px;
                    border-radius: 5px;
                    color: #68ffc0;
                    cursor: pointer;
                }
            }

        }
    }

    .chatbot_box_footer {
        padding: 0px 10px;

        .feedback_txt {
            margin: 8px 0 5px;
            text-align: center;
            color: #ffc168;
            cursor: pointer;
            text-decoration: underline;

            &:hover {
                color: #ffffff;
            }
        }

        .form-group {
            position: relative;
            margin: 0px;

            .form-control {
                border-radius: 80px;
                padding: 10px 50px 10px 15px;
                border: 3px solid rgba(255, 255, 255, 0.15);
                margin: 0;
                background: none;
                box-shadow: 0 1px 8px -1px rgba(162, 169, 176, 0.6);
                height: auto;

                &::-webkit-input-placeholder {
                    color: #656d75;
                }

                &::-moz-placeholder {
                    color: #656d75;
                }

                &:hover {
                    border-color: $serachbar-color;

                    &+.btn {
                        background: $serachbar-color;

                        svg {
                            color: $send-svg-hcolor;
                        }
                    }
                }

                &:focus {
                    color: #ffffff;
                    border-color: $serachbar-color;

                    &+.btn {
                        background: $serachbar-color;

                        svg {
                            color: $send-svg-hcolor;
                        }
                    }

                    &::-webkit-input-placeholder {
                        font-size: 0px;
                    }

                    &::-moz-placeholder {
                        font-size: 0px;
                    }
                }
            }

            .btn {
                position: absolute;
                right: 10px;
                top: 6px;
                background: #fff;
                width: 36px;
                height: 36px;
                border-radius: 50%;
                border: none;
                line-height: 1;
                box-shadow: none;

                svg {
                    color: #656d75;
                }

                path {
                    fill: currentColor;
                }
            }
        }
    }
}
</style>

<style lang="scss">
.chatbot .cb_message_item span {
    p {
        margin-bottom: 0px;

        &:last-child {
            margin-bottom: 0px;
        }

        a {
            color: #7aceff;

            &:hover {
                color: #ffd400;
            }
        }
    }
}
</style>